module.exports = __webpack_public_path__ + "static/spencer-5167c104c9727109521c2146571177ac.jpeg";